export function validaNumeroDigitado(tipoJogo, strNumero) {
  //Busca as informações de prêmio maior e menor
  const tnyPremioMenor = tipoJogo.tnyNumeroMin;
  const tnyPremioMaior = tipoJogo.tnyNumeroMax;
  const tnyUnidade = tipoJogo.tnyUnidade;
  const tnyTamanhoMax = tipoJogo.tnyTamanhoMax;
  const tnyTamanhoMin = tipoJogo.tnyTamanhoMin;
  const chrSeparador = tipoJogo.chrSeparador;

  const strNumeroPuro = strNumero.split(chrSeparador.trim()).join("");

  if (
    strNumeroPuro.length > tnyTamanhoMax ||
    strNumeroPuro.length < tnyTamanhoMin ||
    strNumeroPuro.length % tnyUnidade > 0
  ) {
    return false;
  }

  if (tnyUnidade > 0 && strNumeroPuro.length % tnyUnidade == 0) {
    let aposta = 0;
    for (let i = 0; i < strNumeroPuro.length; i = i + tnyUnidade) {
      //Pega o número
      aposta = strNumeroPuro.substring(i, i + tnyUnidade);
      if (!(aposta >= tnyPremioMenor && aposta <= tnyPremioMaior)) {
        return false;
      }
    }
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/loteria/utils/modalidadeUtils.js